module.exports = __webpack_public_path__ + "static/media/DroneRedMap.3dabee44.svg";